import React, { Component } from 'react';
import { observer } from "mobx-react";
import 'Styles/SmrHeader.scss';
import LoginStore from 'Stores/loginStore';
import AppStore from 'Stores/AppStore';
import Popup from "Components/Common/popup";
import ButtonSwitcher from 'Components/Common/ButtonSwitcher';
import { ShowModal } from 'Utils/CommonFunctions';

class SmrHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let pageTitle = AppStore.pageTitle + AppStore.pageTitleAdditionalInfo;
        return (
            <div className='smr-header'>
                <Popup className="smr-header-title-container right-popup" popupText={pageTitle}>
                    <div className="smr-header-title">
                        {pageTitle}
                    </div>
                </Popup>
                <div className="smr-header-buttons-container">
                    {
                        AppStore.IsHeaderProductModeSwitcherVisibleForCurrentPage() == false ? "" : (
                            <ButtonSwitcher
                                className={
                                    AppStore.modalSettings?.blockProductSwitcher == true
                                        ? "disabled"
                                        : AppStore.IsHeaderProductModeSwitcherEnabledForCurrentPage() == false
                                            ? "disabled-opacity"
                                            : ""
                                }
                                getButtonsInfos={() => [
                                    AppStore.IsHeaderProductModeSwitcherBottonAllVisible() == false ? null :
                                        {
                                            itemId: "all",
                                            text: "Все"
                                        },
                                    {
                                        itemId: "documents",
                                        text: "Документооборот"
                                    },
                                    {
                                        itemId: "events",
                                        text: "Совещания"
                                    },
                                ].filter(it => it != null)}
                                setSelected={(itemId) => {
                                    if (AppStore.IsHeaderProductModeSwitcherEnabledForCurrentPage() == false) {
                                        if (itemId == "events") {
                                            ShowModal({
                                                canBeClosed: true,
                                                header: "Раздел «Совещания» недоступен",
                                                children: `Раздел «Совещания» недоступен, потому что либо у вас версия СЭД «ДЕЛО» 24.2 или более ранняя, либо в настройках СЭД «ДЕЛО» отсутствует лицензия «Управление совещаниями»${AppStore.IsNeedCheckMeetingSwitcherEnabledCurrentUser() ? ", либо в настройках абсолютных прав пользователя не включен параметр «Работа с событиями»" : ""}.`,
                                                className: '',
                                                buttons: [{
                                                    content: "Закрыть",
                                                    closer: true
                                                }],
                                                width: "500px"
                                            });
                                        }
                                        return;
                                    }

                                    if (AppStore.modalSettings?.blockProductSwitcher)
                                        return;

                                    AppStore.SaveSettingProductMode(itemId == "all" ? null : itemId == "events", itemId == "all");
                                }}
                                getSelected={() => AppStore.GetIsAllProductModes() ? "all" : AppStore.isMeeting ? "events" : "documents"}
                            />
                        )
                    }
                    <button className='log-out-button'
                        onClick={LoginStore.LogOut.bind(LoginStore)}>Выход</button>
                </div>
            </div>
        );
    }
}

export default observer(SmrHeader);